import { render } from "./CyberDefenses.vue?vue&type=template&id=671c650e"
import script from "./CyberDefenses.vue?vue&type=script&lang=js"
export * from "./CyberDefenses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__